import React, {
  useEffect,
  useState,
} from "react";

import {
  Table,
  Button,
  Row,
  Col,
  App,
} from "antd";

import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import {
  useNavigate,
} from "react-router-dom";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  deleteGenericName,
} from "../genericNameThunks";

import {
  selectGenericNames,
} from "../../../store/commonSelectors/lookupsSelectors";

import {
  fetchGenericNames,
} from "../../../store/commonThunks/lookups";

import {
  getAccessType,
} from "../../../lib/functions";

import {
  useIsAdminUser,
} from "../../../lib/accessList";
import { setIsEditGenericName, setSelectedGenericName } from "../genericNameSlice";

const GenericNameList = () => {

  const { modal } = App.useApp();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const genericNames =
    useSelector(selectGenericNames);

  let [access_type, access_type_set] =
    useState("");

  const [pagination, setPagination] =
    useState({
      current: 1,
      pageSize: 10,
    });

  const isAdminUser =
    useIsAdminUser();

  const authInfo =
    useSelector(
      (state) => state.auth?.auth_info
    );

  const canEdit =
    authInfo?.can_edit === 1;

  const canDelete =
    authInfo?.can_delete === 1;

  useEffect(() => {

    const access =
      getAccessType("generic_name");

    access_type_set(access);

  }, []);

  // 👈 this was missing — nothing ever populated the list
  useEffect(() => {
    dispatch(fetchGenericNames());
  }, [dispatch]);

  const handleTableChange = (
    pagination
  ) => {

    setPagination(pagination);
  };

  const handleDelete = async (
    generic_name_id,
    generic_name
  ) => {

    try {

      await dispatch(
        deleteGenericName(
          generic_name_id
        )
      ).unwrap();

      modal.success({
        title:
          "Generic Name deleted successfully",
      });

      dispatch(fetchGenericNames());

    } catch (error) {

      modal.warning({
        title:
          error.message ||
          "Delete failed",
      });
    }
  };

  const columns = [

    {
      title: "NO.",
      render: (_, __, index) =>
        index + 1,
    },

    {
      title: "Generic Name",

      dataIndex: "generic_name",

      sorter: (a, b) =>
        a.generic_name?.localeCompare(
          b.generic_name
        ),
    },

    ...(access_type === "WRITE"
      ? [
          {
            title: "Actions",

            render: (_, record) => (
              <>

                <Button
                  type="link"

                  disabled={
                    !(isAdminUser || canEdit)
                  }

                  onClick={() => {

                    dispatch(
                      setSelectedGenericName(
                        record
                      )
                    );

                    dispatch(
                      setIsEditGenericName(
                        true
                      )
                    );

                    navigate(
                      "addNewGenericName"
                    );
                  }}

                  icon={<EditOutlined />}
                />

                <Button
                  type="link"
                  danger

                  disabled={
                    !(
                      isAdminUser ||
                      canDelete
                    )
                  }

                  onClick={() =>
                    modal.confirm({
                      title:
                        "Are you sure?",

                      content:
                        `This will delete generic name: ${record.generic_name}`,

                      okText:
                        "Yes, Delete",

                      cancelText:
                        "Cancel",

                      onOk: () =>
                        handleDelete(
                          record.generic_name_id,
                          record.generic_name
                        ),
                    })
                  }

                  icon={
                    <DeleteOutlined />
                  }
                />

              </>
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {

    dispatch(
      setSelectedGenericName(null)
    );

    dispatch(
      setIsEditGenericName(false)
    );

  }, [dispatch]);

  return (
    <>

      <Row
        justify="end"

        style={{
          marginBottom: "32px",
          marginTop: "32px",
        }}
      >

        <Col>

          {access_type == "WRITE" && (
            <>

              <Button
                type="primary"
                className="traic-button"

                icon={<PlusOutlined />}

                style={{
                  minWidth: "112px",
                  height: "36px",
                  fontSize: "14px",
                  fontWeight: 500,
                }}

                onClick={() => {

                  dispatch(
                    setSelectedGenericName(
                      null
                    )
                  );

                  dispatch(
                    setIsEditGenericName(
                      false
                    )
                  );

                  navigate(
                    "/inventory/generic-names/addNewGenericName"
                  );
                }}
              >
                Add New
              </Button>

            </>
          )}

        </Col>

      </Row>

      <Table
        columns={columns}
        dataSource={genericNames}
        rowKey="generic_name_id"

        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: [
            "10",
            "20",
            "50",
          ],
        }}

        onChange={handleTableChange}

        scroll={{ x: "max-content" }}
      />

    </>
  );
};

export default GenericNameList;